export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`} aria-label="VenTuhi Compliance">
      <span className="brand-mark__glyph" aria-hidden="true">
        <span className="brand-mark__door" />
        <span className="brand-mark__spark" />
      </span>
      <span className="brand-mark__text">
        <strong>VenTuhi</strong>
        {!compact && <small>Compliance</small>}
      </span>
    </div>
  )
}
